import { useNavigate } from 'react-router-dom';
import { FaUser } from 'react-icons/fa';
import { AiFillSave } from 'react-icons/ai';
import { MdHomeFilled, MdNotifications, MdSettings } from 'react-icons/md';
import { BiLogOut } from 'react-icons/bi';

import { useAuthContext } from '../hooks/useAuthContext';
import { useLogout } from '../hooks/useLogout';

export default function Sidebar() {
  const navigate = useNavigate()
  const { authUser } = useAuthContext()
  const { logout } = useLogout()

  if (authUser) {
    return (
      <div className="d-flex flex-column justify-content-start sticky-top align-items-center sidebar pt-2 min-vh-100">
        {/*<Link to="/" className="d-flex mx-auto my-3 align-items-center text-white link-underline link-underline-opacity-0 rfs-1">
            <MdMenu className='sidebar-icon mx-1' />
            <span className="d-none d-md-inline">Menu</span>
          </Link>*/}

        <div className="d-none d-md-flex flex-column align-items-center mt-5">
          <img className="w-25 h-25 rounded-circle" src={authUser?.profileImg || "/gunslinger.jpg"} />
          <span className="rfs-3 text-center">{authUser.fullname}</span>
        </div>

        <ul className="d-flex nav nav-pills nav-justify flex-column align-items-center ms-1 mt-5" id="menu">
          <li className="nav-item rfs-3 mb-3">
            <button onClick={() => navigate('/')} className="d-flex flex-sm-column flex-md-row align-items-center btn nav-link">
              <MdHomeFilled className='sidebar-icon mx-2' />
              <span className="d-none d-md-inline">Home</span>
            </button>
          </li>

          <li className="nav-item rfs-3 mb-3">
            <button onClick={() => navigate(`/users/${authUser.id}`)} className="d-flex flex-sm-column flex-md-row align-items-center btn nav-link">
              <FaUser className='sidebar-icon mx-2' />
              <span className="d-none d-md-inline">Profile</span>
            </button>
          </li>

          <li className="nav-item rfs-3 mb-3">
            <button onClick={() => navigate(`/users/${authUser.id}/notifications`)} className="d-flex flex-sm-column flex-md-row align-items-center btn nav-link">
              <MdNotifications className='sidebar-icon mx-2' />
              <span className="d-none d-md-inline">Notifications</span>
            </button>
          </li>

          <li className="nav-item rfs-3 mb-3">
            <button onClick={() => navigate(`/users/${authUser.id}/savedPosts`)} className="d-flex flex-sm-column flex-md-row align-items-center btn nav-link">
              <AiFillSave className='sidebar-icon mx-2' />
              <span className="d-none d-md-inline">Saved Posts</span>
            </button>
          </li>

          {/*<li className="nav-item rfs-3 mb-3">
              <button className="d-flex flex-sm-column flex-md-row align-items-center btn nav-link">
                <MdSettings className='sidebar-icon mx-2' />
                <span className="d-none d-md-inline">Settings</span>
              </button>
            </li>*/}

          <li className="nav-item rfs-3 my-5">
            <button
              type='button'
              onClick={logout}
              className="d-flex flex-sm-column flex-md-row align-items-center btn nav-link"
            >
              <BiLogOut className='sidebar-icon mx-2' />
              <span className="d-none d-md-inline">Logout</span>
            </button>
          </li>
        </ul>
      </div>
    )
  }
}
